import TimeoutModal from '../../pages/TimeoutModal';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isUserLoggedIn, getUserInfo, aboutToExpire, isCurrentUserKeyMaster } from '../../utilities/AuthService';
import { isCurrentUserAdmin } from '../../utilities/AuthService';
import { EXECUTIONS, ADMIN, SNACKPACK,EDFI_CREDINTIAL_MANAGER, LOGOUT } from '../../navigator/links';
import './index.css';
import KsdeLogo from '../../resources/ksde-logo.png';
import StringListedItems from 'components/List-Display/fullitemlisted';

export default function AppHeader(): JSX.Element {
  const isUserAdmin = isCurrentUserAdmin();
  const isUserKeyMaster = isCurrentUserKeyMaster();
  const userLoggedIn = isUserLoggedIn();
  const userInfo = getUserInfo();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpenTimeoutModal = () => {
    const seconds = parseInt(import.meta.env.VITE_APP_ABOUT_TO_LOG_OUT_FOR_INACTIVITY_IN_SECONDS || '60');
    setOpen(aboutToExpire(seconds) === 'true');
  };

  useEffect(() => {
    if (!open) {
      const interval = setInterval(() => {
        handleOpenTimeoutModal();
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [open]);

  const handleCloseTimeoutModal = () => setOpen(false);

  function logout() {
    setOpen(false)
    navigate(LOGOUT)
  }

  function getRedirectUri() {
    const uiHostUrl = getStringWithNoTrailingOrLeadingSlashed(import.meta.env.VITE_APP_THIS_UI_HOST);
    const baseUrl = getStringWithNoTrailingOrLeadingSlashed(import.meta.env.VITE_APP_BASE_PATH);
    const logoutApi = getStringWithNoTrailingOrLeadingSlashed(LOGOUT);

    const validationPortalLogoutPage = `${uiHostUrl}/${baseUrl}/${logoutApi}`
    return validationPortalLogoutPage;
  }
  
  function getStringWithNoTrailingOrLeadingSlashed(str: string) {
    return str.replace(/\/+$/, '').replace(/^\/+/, '');
  }

  return (
    <header className='app-header'>
      <div className='app-header-top'>
        <div className='app-header-content'>
          <TimeoutModal open={open} handleCloseTimeoutModal={handleCloseTimeoutModal} logout={logout} />
          <img className='app-header-logo' src={KsdeLogo} alt='KSDE Logo' />
          <div className='app-header_title'>Data Validation Portal</div>
          <div className='app-header_user'>
            {userLoggedIn && (
              <>
                <div className='app-header_subtitle_logout' onClick={logout}>
                  Log Out
                </div>

                {userInfo && userInfo.Username && <div className='app-header_subtitle_username'>{userInfo?.Username}</div>}
                {userInfo && userInfo.Role && <div className='app-header_subtitle_username'><StringListedItems items={userInfo?.Role}></StringListedItems></div>}
                {userInfo && userInfo.DistrictName && <div className='app-header_subtitle_username'>District: {userInfo?.OrganizationId || ''} {userInfo?.DistrictName}  ({userInfo?.DistrictId || ''})</div>}
                {userInfo && userInfo.SchoolName && <div className='app-header_subtitle_username'>School: {userInfo?.BuildingId || ''} {userInfo?.SchoolName}  ({userInfo?.SchoolId || ''})</div>}
              </>
            )}
          </div>
        </div>
      </div>
      <div className='app-header-bottom'>
        <nav>
          {userInfo && (
            <Link className='app-header-nav-link' to={EXECUTIONS}>
              Home
            </Link>
          )}
          {isUserAdmin && (
            <Link className='app-header-nav-link' to={ADMIN}>
              Admin
            </Link>
          )}
          {userInfo && (
            <Link className='app-header-nav-link' to={SNACKPACK}>
              Snack Pack
            </Link>
          )}
           {isUserKeyMaster && userInfo && (
            <Link className='app-header-nav-link' to={EDFI_CREDINTIAL_MANAGER}>
              EDFI Credential Manager
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
